import { objectDeepCopy } from '@src/utils/generalUtil'

export default {
  //
  GS_SET_LOGO(state, payload) {
    state.siteSettingLogoURL = payload
  },
  GS_SET_FAVICON(state, payload) {
    state.siteSettingFaviconURL = payload
    let HtmlFavIcon = document.querySelector("link[rel~='icon']")
    if (payload) HtmlFavIcon.href = payload
  },
  GS_SET_INSTITUTE_NAME(state, payload) {
    state.generalSettingInstituteName = payload
    localStorage.setItem('generalSettingInstituteName', payload)
  },

  GS_SET_SITE_TITLE(state, payload) {
    state.generalSettingSiteTitle = payload
    localStorage.setItem('generalSettingSiteTitle', payload)
    document.title = payload
  },
  SET_CONTACT_SETTINGS(state, payload) {
    state.contactSettings = payload
  },
  SET_BILLING_SETTINGS(state, payload) {
    state.billingSetting = payload
  },
  SET_SITE_SETTINGS(state, payload) {
    state.siteSetting = objectDeepCopy(payload)
  },
  SET_ALLOWED_COUNTRIES(state, payload) {
    state.allowedCountries = objectDeepCopy(payload)
  },
  SET_STUDENT_DISPATCHER(state, payload) {
    state.isStudentDispatcher = payload
    localStorage.setItem('isStudentDispatcher', payload)
  },
}
